export const SET_STORE_INPUT_FIELD_VALUE = "SET_STORE_INPUT_FIELD_VALUE";
export const EMPTY_STORE_INPUT_FIELD_VALUE = "EMPTY_STORE_INPUT_FIELD_VALUE";

export const STORE_INIT = "STORE_INIT";
